<template>
  <div class="content-body">
    <QrCode
      ref="QrCode"
      :name="'QrCode'"
      @onQr="getQRSerial"
      :manual="true"
      :photo="camMode"
      @onPhoto="getCamRes"
    />
    <modalImg ref="imgzoomC" :name="'modalImg'" :arrImg="modalArr" />
    <ModalTaskCreate
      ref="ModalTaskCreate"
      :guid="''"
      :serials="[dataEquipment.serial]"
      :address="dataEquipment.address"
      @onClose="afterCrTask"
    />

    <div id="SerialComp" class="customDropd" style="">
      <div class="card mb-0">
        <div class="card-header">
          <h4 class="form-section">
            <i class="icon-info"></i> {{ modalComp.title }}
          </h4>
          <div class="heading-elements" style="">
            <button
              type="button"
              class="btn btn-warning"
              @click="closeSerCompon()"
              data-html="true"
              :title="$t('tasks.hint.close')"
            >
              <i style="color: #ffffff" class="icon-cross"></i>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="mobileTbl table-responsive">
            <table class="table table-hover mb-0" cellspacing="0">
              <thead>
                <tr>
                  <th
                    class="text-truncate"
                    style="vertical-align: middle"
                    v-for="(name, col) in modalComp.header"
                    :key="col"
                  >
                    <span>{{ name }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in modalComp.data" :key="index">
                  <td
                    :data-title="name"
                    v-for="(name, col) in modalComp.header"
                    :key="col"
                  >
                    <span>{{ data[name] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <ModalTaskInfo ref="taskInfo" />

    <vue-modal :on-close="closeModalMap" name="map-modal">
      <h5 slot="header" style="text-align: center">{{ modalMap.title }}</h5>
      <div class="row row-map">
        <GmapMap
          :center="modalMap.position"
          :zoom="17"
          map-type-id="terrain"
          style="height: 600px"
        >
          <GmapMarker
            :position="modalMap.position"
            :clickable="true"
            :draggable="true"
          />
        </GmapMap>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 mb-3"></div>
      </div>
    </vue-modal>

    <div class="row" v-if="showinfo">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="form-section" ref="eqAbout">
              <i class="icon-info"></i> {{ $t("equipm.titles.about") }}
              {{ dataEquipment.serial }}
            </h4>
            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                @click="
                  showinfo = false;
                  actEq = false;
                "
                data-html="true"
                :title="$t('tasks.hint.close')"
              >
                <i style="color: #ffffff" class="icon-cross"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="card-block">
              <ul class="nav nav-tabs">
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.hint.detail') + ' ' + dataEquipment.serial"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataEquipment.tabs.info }"
                    id="base-tab1"
                    data-toggle="tab"
                    @click="dataEquipment.tabs.info = true"
                  >
                    <i class="icon-info"></i>
                  </a>
                </li>
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.table.images')"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataEquipment.tabs.photo }"
                    id="base-tab2"
                    data-toggle="tab"
                    @click="dataEquipment.tabs.photo = true"
                  >
                    <i class="icon-images2"></i>
                  </a>
                </li>
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('equipm.hint.files')"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataEquipment.tabs.files }"
                    id="base-tab3"
                    data-toggle="tab"
                    @click="dataEquipment.tabs.files = true"
                  >
                    <i class="icon-file-text2"></i>
                  </a>
                </li>
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.titles.history')"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataEquipment.tabs.history }"
                    id="base-tab4"
                    data-toggle="tab"
                    @click="dataEquipment.tabs.history = true"
                  >
                    <i class="icon-history"></i>
                  </a>
                </li>
              </ul>

              <div class="row" v-if="dataEquipment.tabs.info">
                <!-- <div
                  class="col-md-12 mt-1"
                  v-if="$store.getters.getDispatcher || $store.getters.getAdmin"
                >
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="showModalTCr()"
                  >
                    <i style="color: #ffffff" class="icon-plus2"></i>
                    {{ $t("tasks.buttons.create") }}
                  </button>
                </div> -->
                <div
                  class="col-md-6"
                  :class="{
                    'offset-md-3': dataEquipment.ProductType != 'Refrigeration',
                  }"
                >
                  <div class="form-body">
                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-eye6"></i>
                        {{ $t("equipm.titles.details") }}
                      </h4>
                    </form>
                    <div class="form-group">
                      <label for="serial">{{
                        $t("equipm.table.serNumber")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          class="form-control border-primary"
                          type="text"
                          id="serial"
                          v-model="dataEquipment.serial"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-qrcode"></i>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="nameEq">{{
                        $t("equipm.table.nameEq")
                      }}</label>
                      <div
                        class="form-control border-primary"
                        style="background-color: #eceeef; min-height: 2em"
                      >
                        {{ dataEquipment.name }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="nameEq">{{
                        $t("equipm.table.extName")
                      }}</label>
                      <input
                        v-if="actEq"
                        type="text"
                        id="extnameEq"
                        class="form-control border-primary"
                        name="extnameEq"
                        v-model="dataEquipment.ExternalName"
                      />
                      <div
                        v-else
                        class="form-control border-primary"
                        style="background-color: #eceeef; min-height: 2em"
                      >
                        {{ dataEquipment.ExternalName }}
                      </div>
                    </div>

                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-mail6"></i>
                        {{ $t("equipm.titles.infoAbManuf") }}
                      </h4>
                    </form>
                    <div class="form-group">
                      <label for="contacts">{{
                        $t("equipm.table.contacts")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <!--<input class="form-control border-primary" type="tel" placeholder="phone number" id="userinput5" pattern="[+]{1}[0-9]{11,14}" v-model="dataEquipment.contacts" disabled>-->
                        <textarea
                          id="contacts"
                          name="contacts"
                          rows="4"
                          class="form-control border-primary"
                          v-model="dataEquipment.contacts"
                          disabled
                        ></textarea>
                        <div class="form-control-position">
                          <i class="icon-address-book"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-6"
                  v-if="dataEquipment.ProductType == 'Refrigeration'"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <form class="form">
                        <h4 class="form-section">
                          <i class="icon-file-text2"></i>
                          {{ $t("equipm.titles.characters") }}
                        </h4>
                      </form>

                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="climaticClass">{{
                              $t("equipm.table.clClass")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="climaticClass"
                                class="form-control border-primary"
                                name="climaticClass"
                                v-model="dataEquipment.climaticClass"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-brightness-contrast"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="defrosting">{{
                              $t("equipm.table.defrosting")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="defrosting"
                                class="form-control border-primary"
                                name="defrosting"
                                v-model="dataEquipment.defrosting"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-svg"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="maxPressure">{{
                              $t("equipm.table.maxPress")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="maxPressure"
                                class="form-control border-primary"
                                name="maxPressure"
                                v-model="dataEquipment.maxPressure"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-meter"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="protectionClass">{{
                              $t("equipm.table.protClass")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="protectionClass"
                                class="form-control border-primary"
                                name="protectionClass"
                                v-model="dataEquipment.protectionClass"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-security"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="ratedCurrent">{{
                              $t("equipm.table.currCons")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="ratedCurrent"
                                class="form-control border-primary"
                                name="ratedCurrent"
                                v-model="dataEquipment.ratedCurrent"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-power2"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="ratedPinp">{{
                              $t("equipm.table.pwrConsump")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="ratedPinp"
                                class="form-control border-primary"
                                name="ratedPinp"
                                v-model="dataEquipment.ratedPinp"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-power-cord"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-file-text"></i>
                      {{ $t("equipm.titles.specif") }}
                    </h4>
                  </form>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="artcile">{{
                          $t("equipm.table.articule")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="artcile"
                            class="form-control border-primary"
                            name="artcile"
                            v-model="dataEquipment.article"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-price-tags"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="titleRefr">{{
                          $t("equipm.table.refrigerant")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="titleRefr"
                            class="form-control border-primary"
                            name="titleRefr"
                            v-model="titleRefr"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-lab"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="dtShipment">{{
                          $t("equipm.table.shipmDate")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <!--<input type="date" id="dtinput1" class="form-control" name="dtShipment" v-model="dataEquipment.dates.shipment" disabled>-->
                          <input
                            type="text"
                            id="dtShipment"
                            class="form-control"
                            name="dtShipment"
                            v-model="dataEquipment.dates.shipment"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-calendar3"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="dtManufacturing">{{
                          $t("equipm.table.manufDate")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="dtManufacturing"
                            class="form-control"
                            name="dtManufacturing"
                            v-model="dataEquipment.dates.manufacturing"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-calendar3"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-if="
                  dataEquipment.components.length > 0 && dataEquipment.tabs.info
                "
              >
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section mb-0">
                      <i class="icon-stack"></i>
                      {{ $t("equipm.titles.components") }}
                    </h4>
                  </form>
                  <div class="col-md-8 offset-md-2">
                    <div class="mobileTbl table-responsive">
                      <table class="table table-hover mb-0" cellspacing="0">
                        <thead>
                          <tr>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.nameEq") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.serNumber") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.count") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.manufacturer") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in dataEquipment.components"
                            :key="index"
                          >
                            <td :data-title="$t('equipm.table.nameEq')">
                              {{ item.Item }}
                            </td>
                            <td :data-title="$t('equipm.table.serNumber')">
                              <a @click.self="showComponDetail($event, item)">{{
                                item.ItemSN
                              }}</a>
                            </td>
                            <td :data-title="$t('equipm.table.count')">
                              {{ item.Quantity }}
                            </td>
                            <td :data-title="$t('equipm.table.manufacturer')">
                              {{ item.Manufacturer }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="dataEquipment.tabs.info">
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <a
                        v-if="
                          dataEquipment.address != null &&
                          dataEquipment.address.length > 5
                        "
                        class=""
                        @click="
                          showModalMapByAddr(
                            dataEquipment.address,
                            dataEquipment.serial
                          )
                        "
                      >
                        <i class="icon icon-location2"></i
                      ></a>
                      <i v-else class="icon-location2"></i>
                      <span>{{ $t("equipm.table.location") }}</span>
                    </h4>
                  </form>
                  <!-- <div class="mobileTbl table-responsive">
                                        <table class="table table-hover mb-0" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.country')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.region')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.city')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.street')}}</th>
                                                    <th style="vertical-align: middle; width: 8%">{{$t('equipm.table.number')}}</th>
                                                    <th style="vertical-align: middle; width: 10%">{{$t('equipm.table.index')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td :data-title="$t('equipm.table.country')">
                                                        <input type="text" id="country" class="form-control" name="country" v-model="dataEquipment.addressT.country" :disabled="!isDisabledAdmin" v-on:change="changeAddress">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.region')">
                                                        <input type="text" id="region" class="form-control" name="region" v-model="dataEquipment.addressT.region" :disabled="!isDisabledAdmin" v-on:change="changeAddress">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.city')">
                                                        <input type="text" id="city" class="form-control" name="city" v-model="dataEquipment.addressT.city" :disabled="!isDisabledAdmin" v-on:change="changeAddress">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.street')">
                                                        <input type="text" id="street" class="form-control" name="street" v-model="dataEquipment.addressT.street" :disabled="!isDisabledAdmin" v-on:change="changeAddress">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.number')">
                                                        <input type="text" id="streetN" class="form-control" name="streetN" v-model="dataEquipment.addressT.streetN" :disabled="!isDisabledAdmin" v-on:change="changeAddress">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.index')">
                                                        <input type="text" id="index" class="form-control" name="index" v-model="dataEquipment.addressT.index" :disabled="!isDisabledAdmin" v-on:change="changeAddress">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> -->

                  <div class="form-group col-md-8 mt-1 mb-0">
                    <input
                      type="text"
                      id="address_old"
                      name="address_old"
                      class="form-control border-primary"
                      v-model="dataEquipment.address"
                      v-on:change="changeAddress"
                    />
                  </div>

                  <div
                    style="float: right; margin-top: 5px"
                    v-if="
                      isDisabledAdmin &&
                      dataEquipment.addressChange &&
                      actEq == false
                    "
                  >
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="sendAddress"
                      >
                        <i class="icon-check2"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="addressCancel"
                      >
                        <i class="icon-cross2"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mt-1" v-if="actEq">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-attachment"></i>
                      {{ $t("tasks.table.images") }}
                    </h4>
                  </form>

                  <div class="form-group">
                    <input
                      type="file"
                      name="file"
                      id="file"
                      class="inputfile"
                      multiple="multiple"
                      accept="image/x-png,image/jpeg"
                      @change="onUploadImg"
                    />
                    <label id="file_loader" for="file">
                      <a class="btn btn-primary btn-min-width"
                        ><i class="icon-upload3"></i>
                        {{ $t("tasks.buttons.file") }}</a
                      >
                    </label>

                    <!-- <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalCAM" @click="$store.state.active_cam = true">
                                            <i style="color: #FFFFFF" class="icon-camera8"></i> {{$t('tasks.buttons.photo')}}
                                        </button> -->
                    <button
                      type="button"
                      class="btn btn-warning"
                      @click="
                        camMode = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.camera')"
                    >
                      <i style="color: #ffffff" class="icon-camera8"></i>
                      {{ $t("tasks.buttons.photo") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="
                        dataEquipment.images = [];
                        dataEquipment.images2 = [];
                      "
                      v-if="dataEquipment.images.length > 0"
                    >
                      <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                    </button>
                  </div>

                  <div class="row">
                    <div
                      class="col-md-12"
                      style="display: flex; flex-wrap: wrap"
                    >
                      <div
                        class="col-xs-3"
                        style="
                          padding: 0;
                          display: flex;
                          flex-direction: column;
                          align-content: center;
                          justify-content: center;
                          margin-bottom: 1em;
                        "
                        v-for="(image, index) in dataEquipment.images"
                        :key="index"
                      >
                        <div class="card hand mb-0" style="margin-left: 5px">
                          <div class="w-100 h-100">
                            <i
                              class="icon-cross delete-image-icon"
                              @click="
                                dataEquipment.images.splice(index, 1);
                                dataEquipment.images2.splice(index, 1);
                              "
                              data-html="true"
                              :title="$t('tasks.hint.delImg')"
                            ></i>
                            <img
                              v-bind:src="image.data"
                              style="max-width: 100%; max-height: 100%"
                              @click="expandDiv(dataEquipment.images, index)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="dataEquipment.tabs.files">
                <div class="col-md-8 offset-md-2">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-file-text2"></i
                      >{{ $t("equipm.table.instructions") }}:
                    </h4>
                  </form>
                  <div class="form-group">
                    <div
                      class="col-md-12"
                      v-for="(file, index) in dataEquipment.instruсtions"
                      :key="index"
                    >
                      <a>
                        <h4 @click="bringfile(file.name)">
                          <img
                            :src="getIcon(file.name)"
                            style="max-height: 2rem; min-height: 1rem"
                          />
                          <span style="text-decoration: underline">{{
                            file.name
                          }}</span>
                        </h4>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-1" v-if="dataEquipment.tabs.photo">
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-images2"></i>
                      {{ $t("tasks.table.images") }}
                    </h4>
                  </form>

                  <div class="row">
                    <div
                      class="col-md-12"
                      style="display: flex; flex-wrap: wrap"
                    >
                      <div
                        class="col-xs-3"
                        style="
                          padding: 0;
                          display: flex;
                          flex-direction: column;
                          align-content: center;
                          justify-content: center;
                          margin-bottom: 1em;
                        "
                        v-for="(image, index) in dataEquipment.ArrayPhoto"
                        :key="index"
                      >
                        <div
                          class="card hand mb-0"
                          style="margin-left: 5px"
                          @click="expandDiv(dataEquipment.ArrayPhoto, index)"
                        >
                          <div
                            class="w-100 h-100 d-flex justify-content-center"
                          >
                            <img
                              v-bind:src="image"
                              style="max-width: 100%; max-height: 100%"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row" v-if="dataEquipment.ArrayPhoto.length < dataEquipment.countPhoto">
                                        <div class="col-md-12">
                                            <form class="form-body">
                                                <div class="form-actions center mt-0 mb-0" style="padding: 0;">
                                                    <button type="button" class="btn btn-secondary" @click="loadPictures()"><i class="icon-download"></i> {{dataEquipment.ArrayPhoto.length + ' / ' + dataEquipment.countPhoto}}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div> -->
                </div>
              </div>

              <div class="row" v-if="dataEquipment.tabs.history">
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-history"></i> {{ $t("titles.history") }}
                    </h4>
                  </form>

                  <div class="mobileTbl table-responsive">
                    <table class="table table-hover mb-0" cellspacing="0">
                      <thead>
                        <tr>
                          <th
                            class="text-truncate"
                            style="vertical-align: middle"
                          >
                            {{ $t("tasks.table.docNumb") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.date") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.status") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.execPers") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.jobs") }}
                          </th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody
                        v-for="(eq, index) in dataEquipment.history"
                        :key="index"
                      >
                        <tr class="hand" @click="showModalTaskinfo(eq.GUID)">
                          <td
                            class="text-truncate"
                            :data-title="$t('tasks.table.docNumb')"
                          >
                            <span>{{ eq.DocNumber }}</span>
                          </td>
                          <td
                            class="text-truncate"
                            :data-title="$t('tasks.table.date')"
                          >
                            <span>{{ eq.Date }}</span>
                          </td>
                          <td
                            class="text-truncate"
                            :data-title="$t('tasks.table.status')"
                          >
                            <span
                              class="tag"
                              :class="$t('tasks.' + eq.Status + '.class')"
                            >
                              {{ $t("tasks." + eq.Status + ".title") }}
                            </span>
                          </td>
                          <td :data-title="$t('tasks.table.execPers')" class="">
                            <span>{{ eq.Executor }}</span>
                          </td>
                          <td :data-title="$t('tasks.table.jobs')" class="">
                            <span>{{ eq.JobS }}</span>
                          </td>
                          <td class="text-truncate">
                            <div
                              class="row"
                              style="float: right; margin-right: 5px"
                            >
                              <button
                                type="button"
                                class="btn btn-warning"
                                @click.self="showModalTaskinfo(eq.GUID)"
                              >
                                <i class="icon-info"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="eq.jobs != null">
                          <td></td>
                          <td colspan="4">
                            <span style="font-size: 0.8em">{{ eq.jobs }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <form class="form">
                <div class="form-actions right" v-if="actEq">
                  <button
                    type="button"
                    class="btn btn-warning mr-1"
                    @click="
                      discardAct();
                      showinfo = false;
                      actEq = false;
                    "
                  >
                    <i class="icon-cross2"></i>
                    {{ $t("equipm.buttons.cancel") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="activateEq()"
                  >
                    <i class="icon-check2"></i> {{ $t("equipm.buttons.add") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="actEqs">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="form-section" ref="eqAbout">
              <i class="icon-stack"></i> {{ $t("equipm.titles.actEqs") }}
            </h4>
            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                @click="actEqs = false"
                data-html="true"
                :title="$t('tasks.hint.close')"
              >
                <i style="color: #ffffff" class="icon-cross"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="card-block">
              <div class="row">
                <div class="col-md-6 mb-1">
                  <div class="form-group">
                    <label for="nameEqs">{{ $t("equipm.table.nameEq") }}</label>
                    <input
                      class="form-control border-primary"
                      type="text"
                      id="nameEqs"
                      v-model="activating.name"
                    />
                  </div>

                  <h5>{{ $t("titles.eq1") }}</h5>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="showModalQR()"
                        data-html="true"
                        :title="$t('equipm.hint.scanQr')"
                      >
                        <i class="icon-qrcode"></i>
                      </button>
                    </div>
                    <input
                      class="form-control border-primary"
                      type="text"
                      :placeholder="$t('equipm.table.serNumber')"
                      id="serial_enter"
                      v-model="dataEquipment.serial"
                      @change="addSerial()"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-warning btn-round"
                        @click="addSerial()"
                      >
                        <i style="color: #ffffff" class="icon-plus2"></i>
                        {{ $t("tasks.buttons.addSerial") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="activating.serials.length > 0">
                  <div
                    class="mobileTbl table-responsive"
                    v-if="activating.serials.length > 0"
                  >
                    <table class="table table-hover mb-0" cellspacing="0">
                      <thead>
                        <tr>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.mainSer") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.serNumber") }}
                          </th>
                          <th style="vertical-align: middle"></th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(eq, index) in activating.serials"
                        :key="index"
                      >
                        <tr>
                          <td class="hand" @click="checkMain(eq)">
                            <i
                              :class="[
                                eq.check
                                  ? 'icon-checkbox-checked'
                                  : 'icon-checkbox-unchecked',
                              ]"
                              style="vertical-align: middle"
                            ></i>
                          </td>
                          <td
                            :data-title="$t('equipm.table.serNumber')"
                            class="hand"
                            @click="checkMain(eq)"
                          >
                            <span>{{ eq.serial }}</span>
                          </td>
                          <td style="vertical-align: middle">
                            <button
                              type="button"
                              class="btn btn-warning"
                              style="float: right"
                              v-on:click="activating.serials.splice(index, 1)"
                            >
                              <i class="icon-bin"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-attachment"></i>
                      {{ $t("tasks.table.images") }}
                    </h4>
                  </form>

                  <div class="form-group">
                    <input
                      type="file"
                      name="file"
                      id="file"
                      class="inputfile"
                      multiple="multiple"
                      accept="image/x-png,image/jpeg"
                      @change="onUploadImg"
                    />
                    <label id="file_loader" for="file">
                      <a class="btn btn-primary btn-min-width"
                        ><i class="icon-upload3"></i>
                        {{ $t("tasks.buttons.file") }}</a
                      >
                    </label>

                    <!-- <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalCAM" @click="$store.state.active_cam = true">
                                            <i style="color: #FFFFFF" class="icon-camera8"></i> {{$t('tasks.buttons.photo')}}
                                        </button> -->
                    <button
                      type="button"
                      class="btn btn-warning"
                      @click="
                        camMode = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.camera')"
                    >
                      <i style="color: #ffffff" class="icon-camera8"></i>
                      {{ $t("tasks.buttons.photo") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="
                        dataEquipment.images = [];
                        dataEquipment.images2 = [];
                      "
                      v-if="dataEquipment.images.length > 0"
                    >
                      <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                  <div
                    class="col-xs-3"
                    style="
                      padding: 0;
                      display: flex;
                      flex-direction: column;
                      align-content: center;
                      justify-content: center;
                      margin-bottom: 1em;
                    "
                    v-for="(image, index) in dataEquipment.images"
                    :key="index"
                  >
                    <div class="card hand mb-0" style="margin-left: 5px">
                      <div class="w-100 h-100">
                        <i
                          class="icon-cross delete-image-icon"
                          @click="
                            dataEquipment.images.splice(index, 1);
                            dataEquipment.images2.splice(index, 1);
                          "
                          data-html="true"
                          :title="$t('tasks.hint.delImg')"
                        ></i>
                        <img
                          v-bind:src="image.data"
                          style="max-width: 100%; max-height: 100%"
                          @click="expandDiv(dataEquipment.images, index)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-1">
                <div class="col-md-12 d-flex justify-content-center">
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="activatingMulti()"
                  >
                    <i class="icon-checkmark2"></i>
                    {{ $t("equipm.buttons.add") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--table-->
    <div class="row match-height">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <form class="form">
              <h4 class="card-title">
                <i class="icon-price-tags"></i> {{ $t("titles.equipment") }}
              </h4>
            </form>
            <div class="heading-elements">
              <!-- <div class="input-group">
                                <div class="input-group-preppend">
                                    <button type="button" class="btn btn-warning btn-round" @click="preActivateEq(); showModalQR()" data-html="true" :title=" $t('equipm.hint.actEq')">
                                        <i style="color: #FFFFFF" class="icon-qrcode"></i>
                                    </button>
                                </div>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-primary btn-round" @click="showActEqs()" data-html="true" :title=" $t('equipm.hint.actStack')">
                                        <i style="color: #FFFFFF" class="icon-stack"></i>
                                    </button>
                                </div>
                            </div> -->
            </div>
          </div>
          <div class="card-body">
            <!-- <div class="col-md-12 d-flex mb-1" style=" margin-top: 5px; justify-content: flex-end;" v-if="this.$store.getters.getAdmin">
                            <button type="button" class="btn btn-warning" @click="showActEqs()">
                                <i style="color: #FFFFFF" class="icon-stack"></i> {{$t('equipm.titles.actEqs')}}
                            </button>
                        </div> -->
            <div class="card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <input
                      class="form-control border-primary"
                      type="text"
                      id="typeFltr"
                      v-model="filterStr"
                      v-on:keyup.enter="findStr()"
                      data-html="true"
                      :title="$t('tasks.hint.find')"
                    />

                    <div
                      class="input-group-append"
                      v-if="filterStr.length > 1 || hidepagin"
                    >
                      <button
                        type="button"
                        class="btn btn-secondary btn-round"
                        @click="clearFind()"
                        data-html="true"
                        :title="$t('tasks.hint.delImg')"
                      >
                        <i class="icon-cross"></i>
                      </button>
                    </div>
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="findStr()"
                        data-html="true"
                        :title="$t('tasks.hint.find')"
                      >
                        <i class="icon-search4 font-medium-4"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mb-1" v-if="selectedFltr != null">
                  <span>{{ $t("equipm.titles.findBy") }} </span>
                  <div
                    class="tag tag-warning hand"
                    @click="showHFltr = !showHFltr"
                  >
                    {{ $t(selectedFltr.title) }}
                    <a class="dropdown-toggle" style="color: white"></a>
                  </div>
                  <div class="dropdown-menu" v-if="showHFltr">
                    <button
                      class="dropdown-item hand"
                      type="button"
                      v-for="(item, index) in headerFilter"
                      :key="index"
                      @click="
                        selectedFltr = item;
                        showHFltr = false;
                      "
                    >
                      {{ $t(item.title) }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4 mb-1">
                  <div class="input-group">
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef"
                      id="typeFltr"
                      @click="filterTypes = !filterTypes"
                    >
                      {{ typeTitle() }}
                    </div>

                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="filterTypes = !filterTypes"
                      >
                        <a
                          class="icon-filter dropdown-toggle"
                          style="color: white"
                        ></a>
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-menu" v-if="filterTypes">
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="
                        filterType = 100;
                        filterTypes = !filterTypes;
                      "
                    >
                      {{ $t("tasks.statuses.all.title") }}
                    </button>
                    <button
                      v-for="(item, index) in $store.state.eq_type"
                      :key="index"
                      class="dropdown-item"
                      type="button"
                      @click="
                        filterType = item.id;
                        filterTypes = !filterTypes;
                      "
                    >
                      {{ $t(item.translate) }}
                    </button>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="input-group">
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef"
                      id="guaranteeFltr"
                      @click="filterGuarantees = !filterGuarantees"
                    >
                      {{ guaranteeTitle() }}
                    </div>

                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="filterGuarantees = !filterGuarantees"
                      >
                        <a
                          class="icon-filter dropdown-toggle"
                          style="color: white"
                        ></a>
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-menu" v-if="filterGuarantees">
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="
                        filterGuar = 100;
                        filterGuarantees = !filterGuarantees;
                      "
                    >
                      {{ $t("tasks.statuses.all.title") }}
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="
                        filterGuar = 1;
                        filterGuarantees = !filterGuarantees;
                      "
                    >
                      {{ $t("equipm.table.guarantee") }}
                    </button>
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="
                        filterGuar = 2;
                        filterGuarantees = !filterGuarantees;
                      "
                    >
                      {{ $t("equipm.table.noGuar") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="mobileTbl table-responsive">
              <table class="table table-hover mb-0" cellspacing="0">
                <thead>
                  <tr>
                    <th class="text-truncate" style="vertical-align: middle">
                      {{ $t("equipm.table.nameEq") }}
                      <a @click="sortData(headerSort.name)"
                        ><i :class="headerSort.name.class"></i
                      ></a>
                    </th>
                    <th style="vertical-align: middle">
                      {{ $t("equipm.table.clName") }}
                    </th>
                    <th class="text-truncate" style="vertical-align: middle">
                      {{ $t("equipm.table.serNumber") }}
                      <a @click="sortData(headerSort.code)"
                        ><i :class="headerSort.code.class"></i
                      ></a>
                    </th>
                    <th class="text-truncate" style="vertical-align: middle">
                      {{ $t("tasks.table.address2") }}
                      <a @click="sortData(headerSort.place)"
                        ><i :class="headerSort.place.class"></i
                      ></a>
                    </th>
                    <th class="text-truncate" style="vertical-align: middle">
                      {{ $t("equipm.table.actDt") }}
                      <a @click="sortData(headerSort.active)"
                        ><i :class="headerSort.active.class"></i></a
                      ><br />({{ $t("equipm.table.manufDate") }})
                    </th>
                    <th class="text-truncate" style="vertical-align: middle">
                      {{ $t("equipm.table.type") }}
                    </th>
                    <th style="vertical-align: middle"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(eq, index) in listFiltered"
                    :key="index"
                    class="hand"
                    @click="
                      actEq = false;
                      getEqInfo(eq.SerialNumber);
                    "
                  >
                    <td :data-title="$t('equipm.table.nameEq')">
                      <div v-if="eq.externallyName != null">
                        <span
                          class="tag tag-warning"
                          style="white-space: pre-wrap"
                          >{{ eq.externallyName }}</span
                        ><br />
                      </div>
                      <span class="hand">{{ eq.Goods }}</span>
                    </td>
                    <td
                      :data-title="$t('equipm.table.clName')"
                      class="text-truncate"
                    >
                      {{ eq.Client }}
                    </td>
                    <td
                      :data-title="$t('equipm.table.serNumber')"
                      class="text-truncate"
                    >
                      <div v-if="eq.mainSerial != null">
                        <span
                          style="font-size: 0.8rem"
                          class="hand tag tag-warning hand"
                          @click.self="getEqInfo(eq.mainSerial)"
                          data-html="true"
                          :title="$t('tasks.hint.detail') + ' ' + eq.mainSerial"
                          >{{ eq.mainSerial }}</span
                        ><br />
                      </div>
                      <span>{{ eq.SerialNumber }}</span>
                      <br />
                      <span
                        v-if="eq.guarantee"
                        class="hand tag tag-success"
                        data-toggle="tooltip"
                        data-html="true"
                      >
                        {{ $t("equipm.table.guarantee") }}
                      </span>
                      <span
                        v-if="!eq.guarantee"
                        class="tag tag-danger"
                        data-toggle="tooltip"
                        data-html="true"
                      >
                        {{ $t("equipm.table.noGuar") }}
                      </span>
                    </td>

                    <td :data-title="$t('tasks.table.address2')">
                      <a
                        v-if="eq.coordinate.lng != null"
                        class="hand"
                        @click.self="showModalMap($event, eq)"
                        >{{ eq.Adress }} <i class="icon icon-location2"></i
                      ></a>
                      <a v-else>{{ eq.Adress }}</a>
                    </td>
                    <td
                      :data-title="
                        $t('equipm.table.actDt') +
                        ' ' +
                        $t('equipm.table.manufDate')
                      "
                    >
                      <span>{{ eq.StartGuarantee }}</span>
                      <br />
                      <span v-if="eq.DateCreate">({{ eq.DateCreate }})</span>
                    </td>

                    <td :data-title="$t('equipm.table.type')">
                      <span>{{ eq.titleType }}</span>
                    </td>

                    <td class="text-truncate">
                      <div class="row" style="float: right; margin-right: 5px">
                        <button
                          type="button"
                          class="btn btn-warning"
                          @click.self="
                            actEq = false;
                            getEqInfo(eq.SerialNumber);
                          "
                          data-html="true"
                          :title="
                            $t('tasks.hint.detail') + ' ' + eq.SerialNumber
                          "
                        >
                          <i class="icon-info font-medium-4"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="" style="text-align: center" v-if="!hidepagin">
              <ul class="pagination">
                <li class="page-item" v-if="pageNumber > 0">
                  <a class="page-link" @click="changePage(pageNumber - 1)"
                    ><i class="icon-arrow-left2"></i
                  ></a>
                </li>

                <li
                  class="page-item"
                  v-bind:class="{ active: pageNumber == page - 1 }"
                  v-for="(page, index) in pages"
                  :key="index"
                >
                  <a
                    v-if="page != '...'"
                    class="page-link"
                    @click="changePage(page - 1)"
                    >{{ page }}</a
                  >
                  <a v-else class="page-link" :id="index">{{ page }}</a>
                </li>

                <li class="page-item" v-if="pageNumber < pageCount - 1">
                  <a class="page-link" @click="changePage(pageNumber + 1)"
                    ><i class="icon-arrow-right2"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import _debounce from "lodash";

export default {
  name: "Equipment",
  data() {
    return {
      camMode: false,
      errors: [],
      listEquipment: [],
      countListLoad: 10,
      guarantee: 365,
      pageCount: null,

      showHFltr: false,
      headerFilter: [
        { field: 1, title: "equipm.table.serNumber" },
        { field: 2, title: "equipm.table.location" },
        { field: 3, title: "equipm.table.nameEq" },
      ],
      selectedFltr: null,

      //filtering
      filterStr: "",
      hidepagin: true,
      //sorting
      headerSort: {
        active: {
          boolDir: false,
          field: "active",
          class: "icon-sort-amount-desc",
        }, //dt activate
        name: { boolDir: true, field: "name", class: "icon-sort-amount-asc" }, //name eq
        place: { boolDir: true, field: "place", class: "icon-sort-amount-asc" }, //location
        code: { boolDir: true, field: "code", class: "icon-sort-amount-asc" }, //serial
      },
      selectSort: {
        field: "active",
        direction: "УБЫВ",
      },

      //displaing info
      showinfo: false,
      actEq: false,
      dataEquipment: {
        guid: null,
        serial: "", //ме-20123469393
        name: "",
        ExternalName: null,
        brand: "",
        ProductType: null,
        article: "",
        refrigerant: {
          weight: "",
          name: "",
        },
        address: null,
        addressChange: false,
        addressBefCH: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          streetN: null,
          index: null,
        },
        components: [],
        dates: {
          manufacturing: "",
          shipment: "",
        },
        contacts: "",
        climaticClass: "",
        defrosting: "",
        lightning: "",
        maxPressure: "",
        protectionClass: "",
        ratedCurrent: "",
        ratedPinp: "",
        instruсtions: [],
        ArrayPhoto: [],

        images: [],
        images2: [],

        countLoad: 3,
        countPhoto: 0,

        tabs: {
          info: true,
          photo: false,
          files: false,
          history: false,
        },
        history: [],
      },

      actEqs: false,
      activating: {
        name: null,
        address: null,
        serials: [],
        main: null,
      },

      //pagination
      pageNumber: 0,
      //coords
      position: {
        latitude: null,
        longitude: null,
        accuracy: null,
      },

      filterTypes: false,
      filterType: 100,

      filterGuarantees: false,
      filterGuar: 100,

      filesLimit: 24,

      modalMap: {
        position: { lat: null, lng: null },
        title: "",
      },

      modalArr: [],

      modalComp: {
        title: null,
        data: [],
        header: [],
      },
    };
  },
  props: {
    //pagination
    size: {
      type: Number,
      required: false,
      default: 10,
    },
    paggSize: {
      type: Number,
      required: false,
      default: 5,
    },
  },
  methods: {
    onUploadImg(e) {
      let tt = null;
      let _this = this;
      if (e.target.files.length > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          const element = e.target.files[i];
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = (e) => {
            var img = new Image();
            img.onload = function () {
              if (img.width > 1500) {
                //зжимання
                var w = img.width;
                var h = img.height;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d"); // Создаем узел атрибута
                var anw = document.createAttribute("width");
                anw.nodeValue = w;
                var anh = document.createAttribute("height");
                anh.nodeValue = h;
                canvas.setAttributeNode(anw);
                canvas.setAttributeNode(anh);
                ctx.drawImage(img, 0, 0, w, h);
                // Чем меньше значение .7, тем более размытым будет нарисованное изображение
                var base64Img = canvas.toDataURL("image/jpeg", 0.6);
                //зжимання

                tt = base64Img.split(",");
              } else {
                tt = img.src.split(",");
              }

              let err = false;
              if (_this.dataEquipment.images.length < _this.filesLimit) {
                let nameFile;
                if (_this.actEqs) {
                  if (_this.activating.main == null) {
                    nameFile =
                      _this.activating.serials[0].serial +
                      "_" +
                      Math.floor(Math.random() * 4999) +
                      ".png";
                  } else {
                    nameFile =
                      _this.activating.main +
                      "_" +
                      Math.floor(Math.random() * 4999) +
                      ".png";
                  }
                  console.log(nameFile);
                } else {
                  nameFile =
                    _this.dataEquipment.serial +
                    "_" +
                    Math.floor(Math.random() * 4999) +
                    ".png";
                }
                _this.dataEquipment.images.push({
                  name: nameFile,
                  data: tt[0] + "," + tt[1],
                }); //'actEq_'
                _this.dataEquipment.images2.push({
                  name: nameFile,
                  data: tt[1],
                });
              } else {
                err = true;
              }

              if (err) {
                _this.$notify({
                  group: "info",
                  title: "Warning",
                  text: "Ліміт файлів " + _this.filesLimit + 1,
                });
              }
            };
            img.src = e.target.result;
          };
        }
      }
    },
    getCamRes(dataCam) {
      this.camMode = false;
      if (this.isValid(dataCam)) {
        let nameFile;
        if (this.actEqs) {
          if (this.activating.main == null) {
            nameFile =
              this.activating.serials[0].serial +
              "_" +
              Math.floor(Math.random() * 4999) +
              ".png";
          } else {
            nameFile =
              this.activating.main +
              "_" +
              Math.floor(Math.random() * 4999) +
              ".png";
          }
        } else {
          nameFile =
            this.dataEquipment.serial +
            "_" +
            Math.floor(Math.random() * 4999) +
            ".png";
        }
        this.dataEquipment.images.push({ name: nameFile, data: dataCam });
        this.dataEquipment.images2.push({
          name: nameFile,
          data: dataCam.split(",")[1],
        });
      }
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].data);
        }
        arr = arr2;
      }

      $("#modalImg").modal("show");
      this.$refs.imgzoomC.onShow(ind, arr);
    },
    getEqList(start, finish) {
      this.listEquipment = [];

      return new Promise((resolve, reject) => {
        let dataRequest = {
          guidClient: this.$store.state.guidClient,
          type: this.filterType,
          status: this.filterGuar,
          start: start,
          finish: finish,
          sort: this.selectSort,
        };

        this.makeQuery("/service/getListProductPage", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let resData = result.arrayProduct;
            if (result.countPage != undefined && this.pageCount == null) {
              this.pageCount = Math.ceil(result.countPage / this.countListLoad);
            }

            let lat = null,
              lng = null;

            for (let i = 0; i < resData.length; i++) {
              lat = null;
              lng = null;

              resData[i].SerialNumber = resData[i].SerialNumber.trim();

              if (resData[i].Goods == "" || resData[i].Goods == null) {
                resData[i].Goods =
                  resData[i].ProductType + " (" + resData[i].SerialNumber + ")";
              }

              resData[i].DateCreate = this.dtFormat(resData[i].DateCreate);
              resData[i].DateShipping = this.dtFormat(resData[i].DateShipping);

              resData[i].guarantee = this.getGuarrantee(
                resData[i].StartGuarantee
              );
              resData[i].StartGuarantee = this.dtFormat(
                resData[i].StartGuarantee
              );

              resData[i].titleType = resData[i].ProductType.trim(); //this.getTypeTit(resData[i].ProductType.trim());

              // "52,3437814:21,2503645"
              if (
                resData[i].coordinate != undefined &&
                resData[i].coordinate != "" &&
                resData[i].coordinate.length > 4 &&
                resData[i].coordinate != null
              ) {
                resData[i].coordinate = resData[i].coordinate.replace(
                  ", ",
                  ":"
                );
                var coord = resData[i].coordinate.split(":");

                if (coord[0]) {
                  if (coord[0].indexOf(",") > -1) {
                    lat = coord[0].replace(",", ".");
                  } else {
                    lat = coord[0];
                  }
                  lat = parseFloat(lat);
                }

                if (coord[1]) {
                  if (coord[1].indexOf(",") > -1) {
                    lng = coord[1].replace(",", ".");
                  } else {
                    lng = coord[1];
                  }
                  lng = parseFloat(lng);
                }

                resData[i].coordinate = { lat: lat, lng: lng };
              } else {
                resData[i].coordinate = { lat: null, lng: null };
              }
              if (resData[i].Adress == "Соответствие") {
                resData[i].Adress = null;
                resData[i].coordinate = { lat: null, lng: null };
              }

              if (this.isValid(resData[i].mainSerial)) {
                resData[i].mainSerial = resData[i].mainSerial.trim();
                //resData[i].externallyName
              } else {
                resData[i].mainSerial = null;
              }
              if (this.isValid(resData[i].externallyName)) {
                resData[i].externallyName = resData[i].externallyName.trim();
              } else {
                resData[i].externallyName = null;
              }

              this.hidepagin = false;
              this.listEquipment.push(resData[i]);
            }
            return resolve();
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      });
    },
    getEqInfo(serial) {
      this.discardAct();
      //ме-21063496548
      if (this.isValid(serial)) {
        let dataRequest = {
          serial: serial,
          userGuid: this.$store.getters.getGuidUser,
          guidClient: this.$store.state.guidClient,
        };
        this.dataEquipment.serial = serial;

        this.makeQuery("/service/productSerialSite", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.dataEquipment.article = result.Articule;

            if (result.GUID != undefined) {
              this.dataEquipment.guid = result.GUID;
            }
            this.dataEquipment.ProductType = result.ProductType;
            if (this.dataEquipment.ProductType == "FMCG Refrigeration") {
              this.dataEquipment.ProductType = "Refrigeration";
            }

            if (result.Goods == "" || result.Goods == null) {
              this.dataEquipment.name =
                this.dataEquipment.ProductType +
                " (" +
                this.dataEquipment.serial +
                ")";
            } else {
              this.dataEquipment.name = result.Goods;
            }
            if (result.ExternalName != undefined) {
              this.dataEquipment.ExternalName = result.ExternalName;
            }

            this.dataEquipment.contacts = result.ContactInfo;

            this.dataEquipment.dates.manufacturing = this.dtFormat(
              result.DateOfProduction
            );
            this.dataEquipment.dates.shipment = this.dtFormat(
              result.DateOfShipment
            );

            this.dataEquipment.refrigerant.weight = result.RefrigerantMass;
            this.dataEquipment.refrigerant.name = result.RefrigerantBrand;
            this.dataEquipment.climaticClass = result.ClimaticClass;
            this.dataEquipment.defrosting = result.Defrosting;
            this.dataEquipment.lightning = result.Lightning;
            this.dataEquipment.maxPressure = result.MaxPressure;
            this.dataEquipment.protectionClass = result.ProtectionClass;
            this.dataEquipment.ratedCurrent = result.RatedCurrent;
            this.dataEquipment.ratedPinp = result.RatedPowerInput;

            this.dataEquipment.address = result.Adress;
            this.dataEquipment.addressBefCH = result.Adress;
            /*if((result.AdressSructure != undefined) && (result.AdressSructure != null)){
                            this.dataEquipment.addressT.country = result.AdressSructure.Country;
                            this.dataEquipment.addressT.region = result.AdressSructure.Region;
                            this.dataEquipment.addressT.city = result.AdressSructure.Location;
                            this.dataEquipment.addressT.street = result.AdressSructure.Street;
                            this.dataEquipment.addressT.streetN = result.AdressSructure.StreetN;
                            this.dataEquipment.addressT.index = result.AdressSructure.PostalCode;
                        }
                        this.dataEquipment.addressBefCH = Object.assign({}, this.dataEquipment.addressT);*/

            if (result.ItemStructure != undefined) {
              for (
                let index = 0;
                index < result.ItemStructure.length;
                index++
              ) {
                this.dataEquipment.components.push(result.ItemStructure[index]);
              }
            }

            if (result.quantityPhoto != undefined) {
              this.dataEquipment.countPhoto = result.quantityPhoto;
              //this.loadPictures();
            }

            /*
                        if((result.ArrayPhoto != undefined) && (result.ArrayPhoto.length > 0)){
                            for (let i = 0; i < result.ArrayPhoto.length; i++) {
                                this.dataEquipment.ArrayPhoto.push({name: result.ArrayPhoto[i].name, data: 'data:image/png;base64,' + result.ArrayPhoto[i].data});
                            }
                        }
                        */

            // if(result.ArrayFiles != undefined) {
            //     this.dataEquipment.instruсtions = [];

            //     let file;
            //     for (let i = 0; i < result.ArrayFiles.length; i++) {
            //         file = result.ArrayFiles[i].name;
            //         if(file != null){
            //             this.dataEquipment.instruсtions.push({name: file, data: null});
            //         }
            //     }

            // }

            this.showinfo = true;

            this.dataEquipment.tabs.info = true;

            this.anchorTo("eqAbout");
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      } else {
        this.showNotification(
          "custom-error",
          "Error",
          "Serial number can not be empty!"
        );
      }
    },
    discardAct() {
      this.dataEquipment.serial = null;
      this.dataEquipment.guid = null;
      this.dataEquipment.name = null;
      this.dataEquipment.ExternalName = null;
      this.dataEquipment.brand = null;
      this.dataEquipment.ProductType = null;
      this.dataEquipment.article = null;
      this.dataEquipment.refrigerant.weight = null;
      this.dataEquipment.refrigerant.name = null;
      this.dataEquipment.dates.manufacturing = null;
      this.dataEquipment.dates.shipment = null;
      this.dataEquipment.contacts = null;
      this.dataEquipment.climaticClass = null;
      this.dataEquipment.defrosting = null;
      this.dataEquipment.lightning = null;
      this.dataEquipment.maxPressure = null;
      this.dataEquipment.protectionClass = null;
      this.dataEquipment.ratedCurrent = null;
      this.dataEquipment.ratedPinp = null;

      this.dataEquipment.address = null;

      this.dataEquipment.addressT.country = null;
      this.dataEquipment.addressT.region = null;
      this.dataEquipment.addressT.city = null;
      this.dataEquipment.addressT.street = null;
      this.dataEquipment.addressT.streetN = null;
      this.dataEquipment.addressT.index = null;

      this.dataEquipment.components = [];
      this.dataEquipment.instruсtions = [];
      this.dataEquipment.ArrayPhoto = [];
      this.dataEquipment.countPhoto = 0;

      this.dataEquipment.images = [];
      this.dataEquipment.images2 = [];

      this.dataEquipment.tabs.info = true;
      this.dataEquipment.tabs.photo = false;
      this.dataEquipment.tabs.files = false;
      this.dataEquipment.tabs.history = false;

      this.dataEquipment.history = [];

      this.activating.name = null;
      this.activating.main = null;
      this.activating.address = null;
      this.activating.serials = [];
    },
    preActivateEq() {
      //this.$store.state.active_qr = true;
      //$('#modalQR').modal('show');
      this.getGPS().then((result) => {
        this.position.latitude = result.latitude;
        this.position.longitude = result.longitude;
        this.position.accuracy = result.accuracy;

        this.actEq = true;
        console.log(result);
      });
    },
    activateEq() {
      let errors = [];

      /*if ( !this.isValid(this.dataEquipment.addressT.country) || (this.dataEquipment.addressT.country == 'Соответствие') ){ this.dataEquipment.addressT.country = null;}
                if ( !this.isValid(this.dataEquipment.addressT.region) || (this.dataEquipment.addressT.region == 'Соответствие') ){ this.dataEquipment.addressT.region = null; }
                if ( !this.isValid(this.dataEquipment.addressT.city) || (this.dataEquipment.addressT.city == 'Соответствие') ){ this.dataEquipment.addressT.city = null; }
                if ( !this.isValid(this.dataEquipment.addressT.street) || (this.dataEquipment.addressT.street == 'Соответствие') ){ this.dataEquipment.addressT.street = null; }
                if ( !this.isValid(this.dataEquipment.addressT.streetN) || (this.dataEquipment.addressT.streetN == 'Соответствие') ){ this.dataEquipment.addressT.streetN = null;}
                if ( !this.isValid(this.dataEquipment.addressT.index) || (this.dataEquipment.addressT.index == 'Соответствие') ){ this.dataEquipment.addressT.index = null;}*/
      if (
        !this.isValid(this.dataEquipment.address) &&
        !this.position.latitude
      ) {
        errors.push(this.$t("tasks.errors.address"));
      }
      if (!this.isValid(this.dataEquipment.ExternalName)) {
        errors.push(this.$t("equipm.errors.nameEq"));
      }

      if (errors.length < 1) {
        let dataRequest = {
          serial: this.dataEquipment.serial,
          nameEq: this.dataEquipment.ExternalName,
          address: this.dataEquipment.addressT,
          fulladdress: this.dataEquipment.address,
          position: this.position,
          arrayImage: this.dataEquipment.images,
          arrayImage2: this.dataEquipment.images2,
          guid: this.dataEquipment.guid,
        };

        if (this.isValid(this.dataEquipment.serial)) {
          this.makeQuery("/service/activeproduct", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              this.showNotification(
                "custom-success",
                "Activated!",
                this.$t("titles.equipment") + " " + this.dataEquipment.serial,
                -1
              );
              this.showinfo = false;
              this.actEq = false;

              this.listEquipment.unshift({
                externallyName: this.dataEquipment.ExternalName,
                Goods: this.dataEquipment.name,
                Client: null,
                mainSerial: null,
                SerialNumber: this.dataEquipment.serial,
                guarantee: true,
                Adress: this.dataEquipment.address,
                coordinate: { lng: null, lat: null },
                StartGuarantee: this.dataEquipment.dates.manufacturing,
                DateCreate: null,
                titleType: this.dataEquipment.ProductType,
              });
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
            });
        }
      } else {
        for (let i = 0; i < errors.length; i++) {
          this.showNotification("custom-error", "Error input", errors[i]);
        }
      }
    },
    sortData(item) {
      if (item.field == this.selectSort.field) {
        item.boolDir = !item.boolDir;
      } else {
        item.boolDir = false;
      }

      if (item.boolDir) {
        this.selectSort.direction = null;
        item.class = "icon-sort-amount-asc";
      } else {
        this.selectSort.direction = "УБЫВ";
        item.class = "icon-sort-amount-desc";
      }

      this.selectSort.field = item.field;
      this.changePage(this.pageNumber);
    },
    bringfile(fileName) {
      for (let i = 0; i < this.dataEquipment.instruсtions.length; i++) {
        if (
          fileName == this.dataEquipment.instruсtions[i].name &&
          this.dataEquipment.instruсtions[i].data != null
        ) {
          fileDownload(this.dataEquipment.instruсtions[i].data, fileName);
          return;
        }
      }

      let dataRequest = {
        serial: this.dataEquipment.serial,
        guid: this.dataEquipment.guid,
        codeModel: this.dataEquipment.model,
        nameFile: fileName,
      };
      this.makeQuery("/service/getproductinctruction", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.dataEquipment.instruсtions.length; j++) {
                if (
                  result[i].name == this.dataEquipment.instruсtions[j].name &&
                  (result[i].data != undefined || result[i].data != null)
                ) {
                  this.dataEquipment.instruсtions[j].data = this.base64String(
                    fileName,
                    result[i].data
                  ); // + result[i].data;
                  if (this.dataEquipment.instruсtions[j].data != null) {
                    fileDownload(
                      this.dataEquipment.instruсtions[j].data,
                      fileName
                    );
                    break;
                  } else {
                    this.showNotification(
                      "custom-info",
                      "Instructions",
                      "Not allowed Type of file " +
                        fileName +
                        ", contact Modern ASU!"
                    );
                    break;
                  }
                }

                if (
                  result[i].name == this.dataEquipment.instruсtions[j].name &&
                  (result[i].data == undefined || result[i].data == null)
                ) {
                  this.showNotification(
                    "custom-info",
                    "Instructions",
                    "Files empty"
                  );
                  break;
                }
              }
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    base64String(file, data) {
      let mediatype = "";

      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };

      if (file.indexOf(".xlsx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (file.indexOf(".xls") > -1) {
        mediatype = "application/vnd.ms-excel";
      } else if (file.indexOf(".txt") > -1) {
        mediatype = "text/plain";
      } else if (file.indexOf(".xml") > -1) {
        mediatype = "text/xml";
      } else if (
        file.indexOf(".png") > -1 ||
        file.indexOf(".jpg") > -1 ||
        file.indexOf(".jpeg") > -1 ||
        file.indexOf(".png") > -1
      ) {
        mediatype = "image/png";
      } else if (file.indexOf(".pdf") > -1) {
        mediatype = "application/pdf";
      } else if (file.indexOf(".doc") > -1) {
        mediatype = "application/msword";
      } else if (file.indexOf(".docx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (file.indexOf(".gz") > -1) {
        mediatype = "application/gzip";
      } else if (file.indexOf(".rar") > -1) {
        mediatype = "application/vnd.rar";
      } else if (file.indexOf(".tar") > -1) {
        mediatype = "application/x-tar";
      } else if (file.indexOf(".ppt") > -1) {
        mediatype = "application/vnd.ms-powerpoint";
      } else if (file.indexOf(".pptx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } else if (file.indexOf(".vsd") > -1) {
        mediatype = "application/vnd.visio";
      } else if (file.indexOf(".zip") > -1) {
        mediatype = "application/zip";
      }

      if (mediatype != "") {
        return b64toBlob(data, mediatype); //'data:' + mediatype + ';base64,';
      } else {
        return null;
      }
    },
    addressCancel() {
      //Object.assign(this.dataEquipment.addressT, this.dataEquipment.addressBefCH);
      this.dataEquipment.address = JSON.parse(
        JSON.stringify(this.dataEquipment.addressBefCH)
      );
      this.dataEquipment.addressChange = false;
    },
    sendAddress() {
      let errors = [];

      /*if ( !this.isValid(this.dataEquipment.addressT.country) ){ errors.push('Fill Country');}
                if ( !this.isValid(this.dataEquipment.addressT.region) ){ this.dataEquipment.addressT.region = ' ';}
                if ( !this.isValid(this.dataEquipment.addressT.city) ){ errors.push('Fill city');}
                if ( !this.isValid(this.dataEquipment.addressT.street) ){ errors.push('Fill street');}
                if ( !this.isValid(this.dataEquipment.addressT.streetN) ) { errors.push('Fill street number');}
                if ( !this.isValid(this.dataEquipment.addressT.index) ){ this.dataEquipment.addressT.index = ' ';}*/
      if (!this.isValid(this.dataEquipment.address)) {
        errors.push(this.$t("tasks.errors.address"));
      }

      if (errors.length < 1) {
        let dataRequest = {
          serial: this.dataEquipment.serial,
          guid: this.dataEquipment.guid,
          address: this.dataEquipment.addressT,
          fulladdress: this.dataEquipment.address,
          guid: this.dataEquipment.guid,
        };
        this.makeQuery("/service/changeadress", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            //Object.assign(this.dataEquipment.addressBefCH, this.dataEquipment.addressT);
            this.dataEquipment.addressBefCH = JSON.parse(
              JSON.stringify(this.dataEquipment.address)
            );
            this.dataEquipment.addressChange = false;
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      } else {
        for (let i = 0; i < errors.length; i++) {
          this.showNotification("custom-error", "Error input", errors[i]);
        }
      }
    },
    changeAddress() {
      this.dataEquipment.addressChange = true;
    },
    getTypeTit(word) {
      for (let i = 0; i < this.$store.state.eq_type.length; i++) {
        if (this.$store.state.eq_type[i].name == word) {
          return this.$t(this.$store.state.eq_type[i].translate);
        }
      }
    },
    typeTitle: function () {
      if (this.filterType == 100) {
        return this.$t("equipm.titles.filtrType");
      } else {
        for (let i = 0; i < this.$store.state.eq_type.length; i++) {
          if (this.filterType == this.$store.state.eq_type[i].id) {
            return this.$t(this.$store.state.eq_type[i].translate);
          }
        }
      }
    },
    guaranteeTitle: function () {
      if (this.filterGuar == 100) {
        return this.$t("equipm.titles.filtrGuarantee");
      } else if (this.filterGuar == 1) {
        return this.$t("equipm.table.guarantee");
      } else if (this.filterGuar == 2) {
        return this.$t("equipm.table.noGuar");
      }
    },
    loadPictures() {
      if (this.dataEquipment.ArrayPhoto.length < 1) {
        let dataRequest = {
          serial: this.dataEquipment.serial,
          client: this.$store.state.listRole.client,
          guid: this.dataEquipment.guid,
        };

        this.makeQuery2("/service/getProductImage", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let arr_img = [],
              mark_old = false;

            if (
              result &&
              result.data &&
              result.data.signed_urls &&
              Array.isArray(result.data.signed_urls)
            ) {
              arr_img = result.data.signed_urls;
            }
            if (
              result &&
              result.data &&
              result.data.data &&
              Array.isArray(result.data.data)
            ) {
              arr_img = result.data.data;
              mark_old = true;
            }
            if (arr_img.length) {
              for (let i = 0; i < arr_img.length; i++) {
                if (mark_old) {
                  this.dataEquipment.ArrayPhoto.push(arr_img[i] + "/preview");
                } else {
                  this.dataEquipment.ArrayPhoto.push(arr_img[i].url);
                }
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    loadHistory() {
      this.dataEquipment.history = [];
      let dataRequest = {
        number: this.dataEquipment.serial,
        guid: this.dataEquipment.guid,
      };

      this.makeQuery("/service/getHistoryTask", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != undefined && result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              result[i].dt = 0;
              if (result[i].Date != null) {
                result[i].dt = Math.round(new Date(result[i].Date));
                result[i].Date = this.dtFormat(result[i].Date);
              }

              if (result[i].Date != null) {
                result[i].StatusTXT = result[i].Status;

                //set status translate
                if (result[i].StatusBP == 1) {
                  //СогласованиеЗаявки
                  result[i].Status = "statuses.new";
                } else if (result[i].StatusBP == 2) {
                  result[i].Status = "statuses.agreed";
                } else if (result[i].StatusBP == 3) {
                  //ВыполнениеЗаявки
                  result[i].Status = "statuses.process";
                } else if (result[i].StatusBP == 4) {
                  //ВнесениеЗатрат
                  result[i].Status = "statuses.finish";
                } else if (result[i].StatusBP == 5) {
                  result[i].Status = "statuses.done";
                } else if (result[i].StatusBP == 6) {
                  result[i].Status = "statuses.cancel";
                }

                if (this.isValid(result[i].Comment)) {
                  result[i].jobs = result[i].Comment;
                } else {
                  result[i].jobs = null;
                }

                this.dataEquipment.history.push(result[i]);
              }
            }

            this.dataEquipment.history.sort(function (obj1, obj2) {
              return obj1.dt - obj2.dt;
            });
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    loadInstructions() {
      let dataRequest = {
        serial: this.dataEquipment.serial,
        guid: this.dataEquipment.guid,
      };
      this.makeQuery("/service/getProductFile", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          this.dataEquipment.instruсtions = [];

          for (let i = 0; i < result.length; i++) {
            if (result[i] != null) {
              this.dataEquipment.instruсtions.push({
                name: result[i],
                data: null,
              });
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    changePage(newPage) {
      this.getEqList(
        newPage * this.countListLoad,
        newPage * this.countListLoad + this.countListLoad
      ).then((result) => {
        this.pageNumber = newPage;
      });
    },
    findStr() {
      console.log("try find", this.filterStr);
      if (this.filterStr.length > 4) {
        //зробити пошук запит і те, що вернеться
        let dataRequest = {
          guidClient: this.$store.state.guidClient,
          userGuid: this.$store.getters.getGuidUser,
          filter: this.filterStr,
          findBy: this.selectedFltr.field,
        };
        this.makeQuery("/service/listfilterproduct", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let resData = result;
            let lat = null,
              lng = null;

            if (resData.length > 0) {
              for (let i = 0; i < resData.length; i++) {
                lat = null;
                lng = null;

                resData[i].DateCreate = this.dtFormat(resData[i].DateCreate);
                resData[i].DateShipping = this.dtFormat(
                  resData[i].DateShipping
                );

                resData[i].guarantee = this.getGuarrantee(
                  resData[i].StartGuarantee
                );
                resData[i].StartGuarantee = this.dtFormat(
                  resData[i].StartGuarantee
                );

                resData[i].titleType = this.getTypeTit(resData[i].ProductType);
                for (let j = 0; j < this.$store.state.eq_type.length; j++) {
                  if (
                    this.$store.state.eq_type[j].name == resData[i].ProductType
                  ) {
                    resData[i].ProductTypeId = this.$store.state.eq_type[j].id;
                    break;
                  }
                }
                if (
                  resData[i].coordinate != undefined &&
                  resData[i].coordinate != ""
                ) {
                  resData[i].coordinate = resData[i].coordinate.replace(
                    ", ",
                    ":"
                  );
                  let coord = resData[i].coordinate.split(":");
                  if (coord[0]) {
                    if (coord[0].indexOf(",") > -1) {
                      lat = coord[0].replace(",", ".");
                    } else {
                      lat = coord[0];
                    }
                    lat = parseFloat(lat);
                  }

                  if (coord[1]) {
                    if (coord[1].indexOf(",") > -1) {
                      lng = coord[1].replace(",", ".");
                    } else {
                      lng = coord[1];
                    }
                    lng = parseFloat(lng);
                  }
                  resData[i].coordinate = { lat: lat, lng: lng };
                } else {
                  resData[i].coordinate = { lat: null, lng: null };
                }
                if (resData[i].Adress == "Соответствие") {
                  resData[i].Adress = null;
                  resData[i].coordinate = { lat: null, lng: null };
                }

                if (this.isValid(resData[i].mainSerial)) {
                  resData[i].mainSerial = resData[i].mainSerial.trim();
                  //resData[i].externallyName
                } else {
                  resData[i].mainSerial = null;
                }
                if (this.isValid(resData[i].externallyName)) {
                  resData[i].externallyName = resData[i].externallyName.trim();
                } else {
                  resData[i].externallyName = null;
                }

                // Adress: "Wiejska 5, 05-200 Wołomin, Poland"
                // Articule: "1045-564-1S"
                // Client: "Modern-Expo S.A."
                // DateCreate: "2021-07-19T08:59:22"
                // DateShipping: "2021-06-08T00:00:00"
                // Goods: "P13A31.000.000-01 E SK Стек 2 (9 комірок правий) (6026 Звг)"
                // SerialNumber: "ме-21073511807                          "
                // ShelfLife: 0
                // StartGuarantee: "2021-09-10T00:00:00"
                //this.listEquipment.unshift(resData[i]);
              }
              this.pageNumber = 0;
              this.listEquipment = resData;
              this.hidepagin = true;
            } else {
              this.showNotification(
                "custom-info",
                this.filterStr,
                "Not found!"
              );
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    clearFind() {
      this.filterStr = "";

      if (this.hidepagin) {
        this.pageCount = null;
        this.getEqList(0, this.countListLoad).then((result) => {
          this.pageNumber = 0;
        });
      }
    },
    closeModalMap: function () {
      this.modalMap.position = { lat: 0, lng: 0 };
      this.$modals.hide("map-modal");
    },
    showModalMap(event, item) {
      if (!e) var e = window.event;
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();

      //запит по координати за серійнком
      if (item.coordinate.lng != null && item.coordinate.lat != null) {
        //resData[i].coordinate = {lat: null, lng: null};
        this.modalMap.position.lat = item.coordinate.lat;
        this.modalMap.position.lng = item.coordinate.lng;
        this.modalMap.title = item.Goods + " (" + item.SerialNumber + ")";
        this.$modals.show("map-modal");
      } else {
        this.showNotification(
          "custom-info",
          this.$t("equipm.table.location"),
          this.$t("errors.emptyGPS")
        );
      }
    },
    showModalMapByAddr(address, title) {
      console.log(address);
      if (address != null && address.length > 5) {
        this.getCoords(address).then((result) => {
          if (result.results.length > 0) {
            this.modalMap.position.lat =
              result.results[0].geometry.location.lat;
            this.modalMap.position.lng =
              result.results[0].geometry.location.lng;

            this.modalMap.title = title;
            this.$modals.show("map-modal");
          }
        });
      }
    },
    showModalTaskinfo(guid) {
      this.$modals.show("InfoTask");
      this.$refs.taskInfo.getTaskInfo(guid);
    },
    showComponDetail(event, el) {
      let dataRequest = {
        serial: el.ItemSN,
        guid: this.dataEquipment.guid,
        userGuid: this.$store.getters.getGuidUser,
      };

      console.log(event);
      //ме-21083544576
      this.makeQuery("/service/getInfoComponents", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
            if (result.data.length > 0) {
              this.modalComp.data = result;
              //let w=$('#SerialComp').attr('style').split(';')[0].replace(/\D/g,'');
              let w = $("#SerialComp").width();
              var tooltipX = event.pageX - 8 - Math.floor(w);
              var tooltipY = event.pageY + 15;
              $("#SerialComp").css({ top: tooltipY, left: tooltipX });
              $("#SerialComp").css({ display: "block" });

              this.modalComp.title = el.Item;
              this.modalComp.header = Object.keys(this.modalComp.data[0]);
            } else {
              this.showNotification(
                "custom-info",
                this.$t("equipm.titles.components"),
                this.$t("titles.nodata")
              );
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    closeSerCompon() {
      $("#SerialComp").css({ display: "none" });
      this.modalComp.data = [];
      this.modalComp.title = null;
      this.modalComp.header = [];
    },
    showModalTCr() {
      this.$modals.show("CreateTask");
      this.$refs.ModalTaskCreate.firstRun();
    },
    afterCrTask() {},
    addSerial() {
      if (this.isValid(this.dataEquipment.serial)) {
        let ser = this.checkPattSer(this.dataEquipment.serial);
        if (ser) {
          this.dataEquipment.serial = ser;
        } else {
          this.dataEquipment.serial = null;
          return;
        }

        if (ser.indexOf("se-") < 0) {
          ser = "ме-" + ser.split("-")[1];
        }
        this.dataEquipment.serial = ser;

        let ind_find = null;

        for (let i = 0; i < this.activating.serials.length; i++) {
          if (this.dataEquipment.serial == this.activating.serials[i].serial) {
            //serial
            ind_find = i;
            break;
          }
        }
        if (ind_find == null) {
          let dataRequest = {
            serial: this.dataEquipment.serial,
            userGuid: this.$store.getters.getGuidUser,
          };
          this.activating.serials.push({
            serial: JSON.parse(JSON.stringify(this.dataEquipment.serial)),
            check: false,
          });
          if (this.activating.address == null) {
            this.makeQuery("/service/productSerial", {
              dataRequest: dataRequest,
              token: this.$store.getters.getUserToken,
            })
              .then((result) => {
                if (result.Adress != undefined) {
                  this.activating.address = result.Adress;
                }
              })
              .catch((result) => {
                this.showNotification("custom-error", "Error", result);
              });
          }
        }
        this.dataEquipment.serial = null;
      }
    },
    showActEqs() {
      this.showinfo = false;
      this.discardAct();

      this.getGPS().then((result) => {
        this.position.latitude = result.latitude;
        this.position.longitude = result.longitude;
        this.position.accuracy = result.accuracy;

        this.actEqs = true;
        console.log(result);
      });
    },
    checkMain(item) {
      if (item.check) {
        //зняти
        item.check = false;
      } else {
        for (let i = 0; i < this.activating.serials.length; i++) {
          this.activating.serials[i].check = false;
        }
        item.check = true;
      }
    },
    activatingMulti() {
      let yay = false;

      if (this.activating.serials.length > 0) {
        this.activating.main = null;

        for (let i = 0; i < this.activating.serials.length; i++) {
          if (this.activating.serials[i].check) {
            this.activating.main = this.activating.serials[i].serial;
            break;
          }
        }

        let dataRequest = {
          serials: [],
          name: this.activating.name,
          coordinates: this.position,
          address: this.activating.address,
          arrayImage: this.dataEquipment.images,
          arrayImage2: this.dataEquipment.images2,
        };

        //якщо багато

        if (this.activating.serials.length > 1) {
          if (this.activating.main == null) {
            this.showNotification("custom-error", $t("errors.mainSer"), "");
            return;
          } else {
            for (let i = 0; i < this.activating.serials.length; i++) {
              if (this.activating.main == this.activating.serials[i].serial) {
                dataRequest.serials.push({
                  serial: this.activating.serials[i].serial,
                  main: null,
                });
              } else {
                dataRequest.serials.push({
                  serial: this.activating.serials[i].serial,
                  main: this.activating.main,
                });
              }
            }
            yay = true;
          }
        } else if (this.activating.serials.length == 1) {
          dataRequest.serials.push({
            serial: this.activating.serials[0].serial,
            main: null,
          });
          yay = true;
        }

        if (yay) {
          this.makeQuery("/service/updateAcivateProduct", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              this.actEqs = false;
              this.discardAct();
              this.showNotification(
                "custom-success",
                this.$t("equipm.titles.actEqs"),
                this.$t("equipm.titles.activated")
              );
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
            });
        }
      }
    },
    getQRSerial(serial) {
      if (this.actEqs) {
        this.dataEquipment.serial = serial;
        this.addSerial({ serial: serial, address: null });
      } else {
        this.getEqInfo(serial);
      }
    },
  },
  computed: {
    listFiltered: function () {
      /*this.pageNumber = 0;
                let find = (this.filterStr.toLowerCase()).trim();
                
                return this.listEquipment.filter(item => {
                    if( find == '' || ((item.SerialNumber != null) && (item.SerialNumber.toLowerCase().indexOf(find) !== -1))
                                    || ((item.Adress != null) && (item.Adress.toLowerCase().indexOf(find) !== -1)) ){
                        return item;
                    }
                    
                    
                });*/
      return this.listEquipment;
    },
    pages: function () {
      let arr = [];
      let max_pages = this.pageCount;
      for (let i = 0; i < max_pages; i++) {
        arr[i] = i + 1;
      }
      let divider = Math.trunc(this.paggSize / 2);
      let start = this.pageNumber - divider;
      let end = this.pageNumber + divider + 1;
      if (start < 0) {
        start = 0;
      }
      let final_arr = arr.slice(start, end);
      if (start + 1 > arr[0]) {
        final_arr.unshift("...");
        final_arr.unshift(1);
      }
      if (end < arr[arr.length - 1]) {
        final_arr.push("...");
      }
      //add last page
      if (this.pageNumber + 1 + divider < max_pages) {
        final_arr.push(max_pages);
      }
      return final_arr;
    },
    titleRefr: function () {
      let a = "",
        b = "";
      if (this.dataEquipment.refrigerant.name) {
        a = this.dataEquipment.refrigerant.name;
      }
      if (this.dataEquipment.refrigerant.weight) {
        b = " (" + this.dataEquipment.refrigerant.weight + ")";
      }
      return a + b;
    },
    isDisabledAdmin: function () {
      if (
        this.$store.state.listRole.admin ||
        this.$store.state.listRole.dispatcher ||
        this.actEq
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  components: {},
  watch: {
    actEqs: function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.discardAct();
        this.showinfo = false;
      }
    },
    "dataEquipment.tabs.info": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.files = false;
        this.dataEquipment.tabs.history = false;
      }
    },
    "dataEquipment.tabs.photo": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.files = false;
        this.dataEquipment.tabs.history = false;

        this.loadPictures();
      }
    },
    "dataEquipment.tabs.files": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.history = false;

        this.loadInstructions();
      }
    },
    "dataEquipment.tabs.history": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.files = false;

        if (this.dataEquipment.history.length < 1) {
          this.loadHistory();
        }
      }
    },
    filterGuar: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageCount = null;
        this.getEqList(0, this.countListLoad).then((result) => {
          this.pageNumber = 0;
        });
      }
    },
    filterType: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageCount = null;
        this.getEqList(0, this.countListLoad).then((result) => {
          this.pageNumber = 0;
        });
      }
    },
  },
  created() {
    this.checkAuthorized()
      .then((result) => {
        this.getEqList(0, this.countListLoad);

        //this.addressBefCH = this.dataEquipment.addressT;
        this.addressBefCH = this.dataEquipment.address;

        this.selectedFltr = this.headerFilter[0];

        if (
          this.$route.params.serial != undefined &&
          this.$route.params.serial != null
        ) {
          let ser = this.$route.params.serial;
          if (ser.indexOf("se-") < 0) {
            ser = "ме-" + ser.split("-")[1];
          }

          this.getEqInfo(ser);
        }
      })
      .catch((err) => {
        this.showNotification(
          "custom-error",
          this.$t("errors.title"),
          this.$t("errors.500")
        );
      });
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    }); // для Hint jQuery
  },
};
</script>

<style scoped>
.table th > .table td {
  padding: 0.75rem 1rem;
}
.col-xs-4 {
  padding: 0;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
#file_loader,
#file_loader2 {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/Equipment.vue